export type FilterMap = { [key: string]: string };

/**
 * The filters one chart request sends: the filter bar's applied values plus any fixed
 * filters the caller supplies (e.g. the plan detail page's planId). A report narrowed to
 * a plan is all-time within that plan, so the date window is dropped — the backend
 * ignores it too, this just keeps the request (and its cache key) honest.
 */
export const buildRequestFilters = (applied: FilterMap, extraFilters?: FilterMap): FilterMap => {
  if (!extraFilters || !Object.keys(extraFilters).length) {
    return applied;
  }
  const base = { ...applied };
  if (extraFilters.planId) {
    delete base.fromDate;
    delete base.toDate;
  }
  return { ...base, ...extraFilters };
};
